import React, { useState } from 'react';
import { FaShoppingCart, FaSearch } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import CartModal from './CartModal';
import { useOrderManager } from './OrderManager';

const Header = ({ searchQuery, setSearchQuery, cartCount }) => {
  const location = useLocation();
  const isSnacksPage = location.pathname === '/snacks' || location.pathname === '/';
  const isPaymentPage = location.pathname === '/pay';
  const [showCartModal, setShowCartModal] = useState(false);
  
  // Use the OrderManager context to handle order processing
  const { 
    isLoading, 
    setIsLoading, // Add setIsLoading from context
    handlePlaceOrder
  } = useOrderManager();

  const toggleCartModal = () => {
    setShowCartModal(!showCartModal);
  };

  // Handle checkout process using the OrderManager
  const handleCheckout = async () => {
    // Show loading state in the cart modal but don't close it yet
    setIsLoading(true);
    
    // Place the order - the cart modal will stay open with a loading indicator
    // Only after the order is successfully placed will we close it
    const success = await handlePlaceOrder(() => {
      // This callback runs after the order is successfully placed
      // Now we can safely close the cart modal
      setShowCartModal(false);
    });
    
    // If order placement failed, stop the loading state
    if (!success) {
      setIsLoading(false);
    }
  };

  return (
    <>
      <header className={`header ${isPaymentPage ? 'payment-header' : ''}`}>
        <div className={`logo ${isPaymentPage ? 'centered-logo' : ''}`}>
          <img src="/assets/images/logo.png" alt="Westgate Cinema Snacks" className="logo-image" />
        </div>
        {isSnacksPage && (
          <div className="search-bar">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search snacks..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        )}
        {!isPaymentPage && (
          <div className="cart-icon" onClick={toggleCartModal}>
            <FaShoppingCart />
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </div>
        )}
      </header>
      
      <CartModal 
        isOpen={showCartModal} 
        onClose={() => setShowCartModal(false)}
        onCheckout={handleCheckout}
        isLoading={isLoading}
      />
    </>
  );
};

export default Header;
